module.exports = __webpack_public_path__ + "img/last.3a51eeb3.svg";